export enum PricePeriods{
    day = 'day',
    week = 'week',
    month = 'month',
    year = 'year',
    max = 'all'
}